import React from "react";
import {
  CustomersDashboard,
  PurchaseOrdersfromCustomers,
  PurchaseOrderstoSuppliers,
  PurchaseRequestDashborad,
  QuotestoCustomersDashboard,
  SuppliersDashboard,
} from "./Components";
import Approvals from "./Components/Approval";
import AlertDashborad from "./Components/AlertDashborad";
import SalesOrderSales from "./Sales/Components/SalesOrderSales";

function Dashboard() {
  return (
    <div className="w-full space-y-4 pb-6">
      {/* Top KPI Stat Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <CustomersDashboard />
        <SuppliersDashboard />
        <PurchaseOrderstoSuppliers />
        <SalesOrderSales />
      </div>

      {/* Approvals & Pending YPR Alerts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-stretch">
        <div className="lg:col-span-8">
          <Approvals />
        </div>
        <div className="lg:col-span-4">
          <AlertDashborad />
        </div>
      </div>

      {/* Category Breakdown & Customer Order Analytics Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <PurchaseRequestDashborad />
        <QuotestoCustomersDashboard />
        <PurchaseOrdersfromCustomers />
      </div>
    </div>
  );
}

export default Dashboard;
